import { render, staticRenderFns } from "./help.vue?vue&type=template&id=1c535599&scoped=true&"
import script from "./help.vue?vue&type=script&lang=ts&"
export * from "./help.vue?vue&type=script&lang=ts&"
import style0 from "./help.vue?vue&type=style&index=0&id=1c535599&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c535599",
  null
  
)

export default component.exports